import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import { AulaConcluidaBotao } from 'Component/AulaConcluida';
import Icone from 'Component/Icone';
import Modulo from 'Interface/Modulos';

interface Props {
  dados: Modulo;
  primeiro?: boolean;
}

const Lista = ({
  dados: { aulas, ...dados },
  primeiro,
}: Props): React.ReactElement => {
  const [aberto, setAberto] = useState<boolean>(false);

  useEffect(() => {
    if (primeiro) {
      setAberto(true);
    }
  }, [primeiro]);

  const concluido = useMemo(() => {
    let concluiu = true;

    aulas?.map((aula) => (!aula.aula_concluida ? (concluiu = false) : null));

    return concluiu;
  }, [aulas]);

  return (
    <React.Fragment>
      <h3
        className={[
          'd-flex justify-content-between',
          'fw-lighter fs-3 text-muted',
          'border-bottom border-dark',
          'mb-3 py-2',
          'cursor-pointer',
        ].class()}
        onClick={() => setAberto(!aberto)}
      >
        {dados.nome}
        <span>
          {concluido && (
            <span className="fs-6 me-3 text-success">Concluído</span>
          )}
          {!aberto ? (
            <Icone nome="chevron-down" />
          ) : (
            <Icone nome="chevron-up" />
          )}
        </span>
      </h3>
      {aberto && (
        <ol className="animate__animated animate__fadeIn fs-5 text-white fw-light">
          {aulas?.map((aula) => (
            <li key={`${aula.id}-${aula.modificado}`}>
              <span className="d-flex justify-content-between py-2">
                <Link
                  to={`aula/${aula.id}`}
                  className="text-white text-decoration-none"
                >
                  {aula.titulo}
                </Link>
                <AulaConcluidaBotao
                  aulaId={aula.id}
                  aulaConcluidaId={aula.aula_concluida?.id}
                />
              </span>
            </li>
          ))}
        </ol>
      )}
    </React.Fragment>
  );
};

export default Lista;
